<style scoped lang="less">
/deep/ .tablestitle {
	color: #333;

	.cell {
		font-weight: 600 !important;
	}

	// font-size: 1rem;
}

.choiostitle {
	display: flex;
	padding: 0.8rem 1rem;
	align-items: center;
	justify-content: space-between;
	background-color: #fff;
	margin-bottom: 1rem;
	border-left: 4px solid #0acf97;

	.choiosvspde {
		/deep/ .el-button-group {
			width: 9rem;

			button:first-child {
				width: 7rem;
				height: 2rem;
				padding: 0 3px;
			}

			button:last-child {
				width: 1.6rem;
				height: 2rem;
				position: relative;
				padding: 0;
				top: 0px;
				left: 0px;
			}
		}
	}

	.choiostitleleft {
		padding: 0.5rem;
		font-size: 0.8rem;
		border-radius: 50%;
		color: #fff;
		background-color: #0acf97;
		border: 1px solid;
		text-align: left;
		margin-left: 0.6rem;
		box-sizing: border-box;

		span {
			font-weight: 900;
			font-size: 1.2rem;
		}
	}

	.choiosvdate {
		width: 10rem;
		margin-right: 2%;

		/deep/ .el-input {
			width: 100%;
		}
	}

	.choiosipt {
		// width: 9rem;
		margin-right: 2%;

		/deep/ .el-input {
			width: 100%;
		}
	}

	.choiostitleright {
		display: flex;
		align-items: center;
		justify-content: flex-end;

		div {
			margin: 0 0.2rem;
		}

		.choiosipt {
			/deep/ .el-input--prefix .el-input__inner {
				height: 2rem;
				padding: 1rem 2rem;
			}

			/deep/ .el-input__prefix {
				top: -3px;
			}

			/deep/ .el-input__suffix {
				top: -3px;
			}
		}
	}
}

.orderstable {
	// margin-top: 1rem;
	padding: 1rem;
	width: 100%;
	background-color: #fff;
	border-top: 4px solid #ab26aa;
	border-radius: 2px;

	.oderlookds {
		background-color: #f41127;
	}

	.oderlookd {
		padding: 0.1rem;
		width: 4rem;
		background: rgb(78, 192, 204);
		color: rgb(255, 255, 255);
		margin: 0 auto;
		border-radius: 5px;
	}

	.tabslis {
		/deep/ & ::-webkit-scrollbar {
			width: 5px;
			height: 8px;
			background: linear-gradient(to right, #2e61bf, #60c363);
		}

		& ::-webkit-scrollbar {
			width: 10px;
			height: 5px;
			// background: red;
		}

		& ::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
			border-radius: 0;
			background: rgba(0, 0, 0, 0.1);
		}

		/deep/ .el-table {
			// th,
			// td {
			// 	text-align: center;
			// }

			td {
				button {
					color: #fff;
					border-radius: 5px;
				}

				.looking {
					background: #0d6efd;
					margin-left: 10px;

					span {
						font-size: 0.6rem;
						font-weight: 800;
					}
				}

				.looking:hover {
					background: #0b67e6;
				}

				.giveempower {
					background: #ff8300;

					span {
						font-size: 0.6rem;
					}
				}

				.giveempower:hover {
					background: #e17000;
				}

				.edit {
					background: #17a001;

					span {
						font-size: 0.6rem;
					}
				}

				.edit:hover {
					background: #1fcf00;
				}

				.delete {
					background: #ec0f25;

					span {
						font-size: 0.6rem;
					}
				}

				.delete:hover {
					background: #ff1128;
				}
			}
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}

		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
			background: linear-gradient(to right, #018761, #39b170);
			// color: #FFF;
		}
	}

	.schooltitle {
		font-size: 1.2rem;
		color: #ab26aa;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ccc;
		padding-bottom: 1rem;
		position: relative;

		button {
			padding: 0.4rem;
			background: #fe8930;
			font-size: 0.6rem;
			border-radius: 3px;
			padding: 0.6rem 1.2rem;
			position: absolute;
			right: 1%;
			color: #fff;

			span {
				color: #fff;
				margin-right: 0.2rem;
				font-weight: 900;
			}
		}

		span.el-icon-s-management {
			display: block;
			padding: 0.4rem;
			border-radius: 50%;
			font-size: 1rem;
			margin-right: 0.4rem;
			box-sizing: border-box;
			background: #ab26aa;
			color: #fff;
		}
	}
}

.paginations {
	height: 3rem;
	line-height: 3rem;

	input {
		width: 3rem;
		height: 1.8rem;
		padding: 0 0 0 0.8rem;
		border: 1px solid #ccc;
	}
}

.addButtonStyle {
	display: flex;
}

.addButtonStyle01 {
	color: white;
	font-size: 1rem;
	background-color: #f7ad3a;
	border: 1px solid #f7ad3a;
	padding: 0.4rem 1rem;
	border-radius: 0.2rem;
	margin-right: 0.5rem;
}

.addButtonStyle02 {
	color: white;
	font-size: 1rem;
	background-color: #db4437;
	border: 1px solid #db4437;
	padding: 0.4rem 1rem;
	border-radius: 0.2rem;
}
/deep/ .el-step {
	flex-basis: 45% !important;
	.el-step__head {
		margin-left: 2rem;
		.el-step__line {
			top: 33px;
		}
	}

	.el-step__icon-inner {
		font-size: 3rem;
	}

	.is-finish {
		color: #018761;
		.el-step__icon {
			background-color: #018761;
		}
	}

	.el-step__head.is-finish {
		border-color: #018761;
	}

	.el-step__icon {
		width: 70px;
		height: 70px;
		background-color: #d4d4d4;
		color: #fff;
		border: none;
	}

	.is-process {
		color: #c0c4cc !important;
	}
}
/deep/ .el-step:nth-of-type(3) {
	flex-basis: 0 !important;
	.el-step__head {
		margin-left: 16px;
	}
}

.flexcenter {
	display: flex;
	align-items: center;
}

.dialog-footer {
	display: flex;
	justify-content: space-between;
}

.formsdata {
	padding: 2rem;
	border-bottom: 1px solid #ccc;
	.formsdata1 {
		.formsdata1s {
			margin: 30px 0;
			p {
				width: 140px;
				text-align: right;
			}
		}

		.scusssaa {
			flex-direction: column;
			p:first-child {
				font-size: 5rem;
				color: #fff;
				background-color: #52c41a;
				border-radius: 50%;
				margin-bottom: 1rem;
			}
			p:nth-of-type(2) {
				font-size: 1.5rem;
				margin-bottom: 1rem;
				color: #000;
			}
		}
	}
}

.formsdata2 {
	.formsdata1s {
		margin: 30px 0;
		p {
			width: 120px;
		}
	}
}
</style>

<style type="text/css">
.msgboxsa {
	width: 570px !important;
	font-size: 20px !important;
}
</style>
<template>
	<div>
		<titles titlename="实训能力模型" titlecontent="这里可以看到实训能力模型一些信息" :mbx="paths"></titles>
		<div class="choios">
			<div class="choiostitle">
				<div class="addButtonStyle col-xs-6 col-sm-6 col-md-6 col-lg-6">
					<p class="addButtonStyle01" style="cursor: pointer;margin-left: 0.4rem;" v-preventReClick>
						<span class="el-icon-circle-plus-outline"></span>
						<span @click="addmodelbilty()">添加能力模型</span>
					</p>
					<p class="addButtonStyle02" style="cursor: pointer;" @click="gouserslist()" v-preventReClick>
						<span class="el-icon-remove-outline"></span>
						<span>批量删除</span>
					</p>
				</div>

				<div class="choiostitleright col-xs-6 col-sm-6 col-md-6 col-lg-6">
					<div class="choiosipt col-xs-6 col-sm-6 col-md-6 col-lg-6">
						<el-input @change="searchs()" placeholder="搜索" prefix-icon="el-icon-search" v-model="search"></el-input>
					</div>
				</div>
			</div>

			<div class="orderstable">
				<div class="paginations">
					每页显示
					<input @change="pagesizechanes()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="pagesize" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table
							ref="multipleTable"
							@select-all="changeallslec"
							@select="changeselect"
							header-row-class-name="tablestitle"
							tooltip-effect="dark"
							:data="tableData"
							border
							style="width: 100%"
						>
							<el-table-column fixed type="selection" :resizable="false" width="55"></el-table-column>
							<!-- <el-table-column prop="Index" label="序号" width="100"></el-table-column> -->
							<el-table-column prop="cm_name" :resizable="false" label="能力模型名称"></el-table-column>
							<el-table-column prop="pro_name" :resizable="false" label="模型所对应专业"></el-table-column>
							<el-table-column prop="log_errResult" :resizable="false" label="模型启用状态" width="120">
								<template slot-scope="scope">
									<p :style="{ color: scope.row.pro_status == 1 ? '#5bb600' : 'red' }">{{ scope.row.pro_status == 1 ? '已启用' : '已禁用' }}</p>
								</template>
							</el-table-column>
							<el-table-column label="创建时间" :resizable="false" width="220">
								<template slot-scope="scope">
									<p>{{ scope.row.creationtime.replace('T', ' ') }}</p>
								</template>
							</el-table-column>
							<el-table-column fixed="right"  :resizable="false" label="操作">
								<template slot-scope="scope">
									<div class="userusec d-sm-none d-md-block">
										<!-- <el-button size="small" :class="'looking'" @click="lookings(scope.row)">
											<el-tooltip class="item" effect="dark" content="查看" placement="bottom-end"><span class="el-icon-view"></span></el-tooltip>
										</el-button> -->
										<el-button @click="lookmodes(scope.row)" style="background-color: #0797ff;" size="mini" icon="el-icon-view">查看</el-button>
										<el-button @click="editmodes(scope.row)" style="background-color: #975fe4;" size="mini" icon="el-icon-edit">编辑</el-button>
										<el-button
											v-if="scope.row.pro_status == 0"
											@click="changedisable(scope.row)"
											style="background-color: #0acf97;"
											size="mini"
											icon="el-icon-check"
										>
											启用
										</el-button>
										<el-button
											v-else="scope.row.pro_status == 1"
											@click="changedisable(scope.row)"
											style="background-color: #ff0000;"
											size="mini"
											icon="el-icon-close"
										>
											禁用
										</el-button>

										<el-popconfirm
											@confirm="clickprovisible(scope.row)"
											confirm-button-text="确定"
											cancel-button-text="取消"
											icon="el-icon-info"
											icon-color="red"
											title="确定删除这条记录吗？"
										>
											<el-button slot="reference" style="background-color: #db4437;margin-left: 10px;" size="mini" icon="el-icon-delete">删除</el-button>
										</el-popconfirm>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>

				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ pagesize }}</span>
						,共
						<span>{{ pagggenums }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :page-size="pagesizes" :total="pagggenums"></el-pagination>
					</div>
				</div>
			</div>

			<el-dialog :visible.sync="lookbilctys" width="60%" center>
				<div slot="title" class="stepstitle">查看能力模型</div>
				<div>
					<el-descriptions class="margin-top" :column="3">
						<el-descriptions-item label="能力名称">{{ lookmodelobj.cm_content }}</el-descriptions-item>
						<el-descriptions-item label="模型所对应专业">{{ lookmodelobj.pro_name }}</el-descriptions-item>
						<el-descriptions-item label="模型启用状态">{{ lookmodelobj.pro_status == 1 ? '已启用' : '已禁用' }}</el-descriptions-item>
						<el-descriptions-item label="创建时间" :span="3">{{ lookmodelobj.creationtime }}</el-descriptions-item>
					</el-descriptions>
					<div>
						<el-table :data="modexslist" style="width: 100%">
							<el-table-column type="index" label="序号" width="100"></el-table-column>
							<el-table-column prop="projectType" label="能力类型名称"></el-table-column>
							<el-table-column prop="projectName" label="能力项目名称"></el-table-column>
						</el-table>
					</div>
				</div>
			</el-dialog>

			<el-dialog :visible.sync="centerDialogVisible" width="60%" :before-close="handleClose">
				<div slot="title" class="stepstitle"></div>
				<div style="width: 100%;">
					<el-steps :active="stapactives">
						<el-step title="第一步 创建能力模型" :class="{ elstepiconactive: stapactives == 1 }"></el-step>
						<el-step title="第二步 添加模型内容" :class="{ elstepiconactive: stapactives == 2 }"></el-step>
						<el-step title="第三步 完成" :class="{ elstepiconactive: stapactives == 3 }"></el-step>
					</el-steps>
					<div class="formsdata">
						<div class="formsdata1" v-if="stapactives == 1">
							<div class="flexcenter formsdata1s">
								<p style="margin-right: 15px;width: 155px;">
									能力模型名称
									<span style="color: red;">*</span>
									：
								</p>
								<el-input v-model="models.cm_name" placeholder="请输入内容"></el-input>
							</div>
							<div class="flexcenter formsdata1s">
								<p style="width: 160px;">
									能力模型所对应专业
									<span style="color: red;">*</span>
									：
								</p>
								<el-select v-model="models.pro_guid" @change="changezy" placeholder="请选择专业" style="width: 88%;">
									<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
								</el-select>
							</div>
							<div class="flexcenter formsdata1s" style="justify-content: flex-start;align-items: flex-start;">
								<!-- style="justify-content: flex-start;align-items: flex-start;" -->
								<p style="margin-right: 16px;width: 155px;">
									内容描述
									<span style="color: red;">*</span>
									：
								</p>
								<el-input v-model="models.cm_content" type="textarea" :autosize="{ minRows: 8, maxRows: 10 }" placeholder="请输入内容"></el-input>
							</div>
						</div>

						<div class="formsdata2" v-if="stapactives == 2">
							<div class="flexcenter formsdata1s">
								<p>能力类型名称：</p>
								<el-select v-model="rebiltyvalue" placeholder="请选择类型名称" style="width: 100%;" @change="changesrebiltyval">
									<el-option v-for="item in rebiltyvaluelist" :key="item.pid" :label="item.parentProjectName" :value="item.pid"></el-option>
								</el-select>
							</div>
							<div class="flexcenter formsdata1s">
								<p>能力项目名称：</p>
								<el-select v-model="abilityproject" placeholder="请选择项目名称" style="width: 100%;">
									<el-option v-for="item in abilityprojectlist" :key="item.pid" :label="item.projectName" :value="item.pid"></el-option>
								</el-select>
							</div>
							<!-- 
							 <div class="flexcenter">
							 	<p>所占比重（%）：</p>
							 	<el-select v-model="value" placeholder="请选择">
							 		<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
							 	</el-select>
							 </div>
							 <div class="flexcenter">
							 	<p>内容描述：</p>
							 	<el-select v-model="value" placeholder="请选择">
							 		<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
							 	</el-select>
							 </div>
							 -->
							<div class="flexcenter" style="justify-content: center; margin: 2rem 0;">
								<el-button type="danger" icon="el-icon-plus" style="background-color: #FF5C00;" @click="addbilctyles">添加</el-button>
								<el-button
									@click="
										rebiltyvalue = '';
										abilityproject = '';
									"
									type="danger"
									icon="el-icon-refresh-right"
									style="background-color: #D7D7D7;border: none;"
								>
									重置
								</el-button>
							</div>
							<div>
								<el-table :data="examinetableData" style="width: 100%">
									<el-table-column type="index" label="序号" width="100"></el-table-column>
									<el-table-column prop="projectType" label="能力类型名称"></el-table-column>
									<el-table-column prop="projectName" label="能力项目名称"></el-table-column>
									<!-- <el-table-column prop="projectName" label="占比值"></el-table-column> -->
									<el-table-column label="操作" fixed="right" width="220">
										<template slot-scope="scope">
											<div @click="delectesaf(scope.row)"><p class="colbtn" style="color: #0797ff;text-decoration: underline;cursor: pointer;">删除</p></div>
										</template>
									</el-table-column>
								</el-table>
							</div>
							<!-- <div class="flexcenter" style="margin-top: 1rem;justify-content: flex-end;">
								<p class="colbtn" @click="prepspages()" style="margin: 0 5px;color: #0797ff;cursor: pointer; text-decoration: underline;">上一页</p>
								<p class="colbtn" @click="nextpages()" style="margin: 0 10px;color: #0797ff;cursor: pointer;text-decoration: underline;">下一页</p>
							</div> -->
						</div>

						<div class="formsdata1" v-if="stapactives == 3">
							<div class="flexcenter scusssaa">
								<p class="el-icon-circle-check"></p>
								<p>{{ ismodels == 1 ? '编辑成功' : '添加成功' }}</p>
								<p>
									可以到实训能力模式页面设置启用该模型
									<span style="color: #ff0000;font-size: 22px;">请点击完成即可{{ ismodels == 1 ? '完成编辑' : '完成添加' }}</span>
								</p>
							</div>
						</div>
					</div>
				</div>

				<span slot="footer" class="dialog-footer">
					<span v-if="stapactives == 3"></span>
					<span v-if="stapactives == 1"></span>
					<el-button v-if="stapactives == 2" @click="prveclicks()">上一步</el-button>
					<el-button type="primary" @click="nextclicks()">{{ stapactives == 3 ? '完成' : '下一步' }}</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import {
	chanputcapabilitymodelm,
	changecapabilitymodelm,
	changeGetcmprlist,
	getGetcmpagelist,
	changeDisabled,
	changeDeleteCm,
	changeGetprojectType,
	changeGetprojectName
} from '@/request/api/pingtai/trainsplan.js';

import { GetzyProfList } from '@/request/api/mange/mange.js';

import { uniqueFunc } from '@/utils/utils';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			isFlag: 2,
			pageindex: 1,
			pagesize: 10,
			pagggenums: 0,
			tabsnun: 10,
			// 搜索
			search: '',
			// 时间选择
			vdate: '',
			edate: '',
			sdate: '',
			edates: '',
			// 标题
			paths: [
				{
					path: '/allmanage/userabilitymodel',
					name: '实训能力模型'
				}
			],
			tableData: [],
			// 弹窗
			centerDialogVisible: false,
			stapactives: 1,
			// 输入能力模型
			models: {
				cm_name: '',
				pro_name: '',
				procontent: '',
				proweight: '',
				pro_guid: '',
				cm_content: ''
			},
			options: [],
			zyvalue: '',
			rebiltyvalue: '',
			abilityproject: '',
			examinetableData: [],
			examinetableDataesli: [],
			delectcmguidlist: [],
			// 专业列表
			prolist: [],
			// 类型名称列表
			rebiltyvaluelist: [],
			abilityprojectlist: [],
			abiltypageidx: 0,
			zyobj: {},
			// 查看模型列表
			lookbilctys: false,
			lookmodelobj: {},
			modexslist: [],
			ismodels: 0
		};
	},
	components: {
		titles
	},
	mounted() {
		this.gfarzPageLogList();
		this.getprolist();
	},
	computed: {
		pagesizes() {
			return Number(this.pagesize);
		}
	},
	created() {
		AppOptions.appEmpty = false;
	},
	methods: {
		addmodelbilty() {
			// 添加能力模型
			let models = {
				cm_name: '',
				pro_name: '',
				procontent: '',
				proweight: '',
				pro_guid: '',
				cm_content: ''
			};
			this.models = models;
			this.examinetableDataesli = [];
			this.centerDialogVisible = true;
			this.stapactives = 1;
			this.examinetableData = [];
			this.ismodels = 0;
			this.getprolist();
		},
		// 添加列表
		addbilctyles() {
			if (this.rebiltyvalue == '') {
				this.$message('请选择类型名称');
				return;
			}

			if (this.abilityproject == '') {
				this.$message('请选择能力项目名称');
				return;
			}

			let rebiltyobj = {};
			this.rebiltyvaluelist.forEach(item => {
				if (item.pid == this.rebiltyvalue) {
					rebiltyobj = item;
				}
			});

			let abilityproobj = {};
			this.abilityprojectlist.forEach(item => {
				if (item.pid == this.abilityproject) {
					abilityproobj = item;
				}
			});
			// console.log("examinetableDataesli》》》",this.examinetableDataesli)
			this.examinetableDataesli.push({
				pid: this.abilityproject,
				projectName: abilityproobj.projectName,
				ptypeid: this.rebiltyvalue,
				projectType: rebiltyobj.parentProjectName
			});

			this.examinetableData = uniqueFunc(this.examinetableDataesli, 'pid');

			// console.log("examinetableData》》》",this.examinetableData)

			this.rebiltyvalue = '';
			this.abilityproject = '';
		},
		// 查看详情
		lookmodes(itm) {
			this.lookmodelobj = itm;

			this.lookmodelobj.creationtime = this.lookmodelobj.creationtime.replace('T', ' ');
			this.lookbilctys = true;
			let changecmpr = {
				pageIndex: 1,
				pageSize: 100,
				cm_guid: itm.cm_guid
			};
			changeGetcmprlist(changecmpr).then(res => {
				if (res.data.code >= 0) {
					this.modexslist = res.data.data.list;
				}
			});
		},
		editmodes(itm) {
			this.models = itm;
			// console.log(this.models);
			this.centerDialogVisible = true;
			this.ismodels = 1;
			this.stapactives = 1;
			this.zyobj.pro_name = itm.pro_name;
			let changecmpr = {
				pageIndex: 1,
				pageSize: 100,
				cm_guid: itm.cm_guid
			};
			this.getprolist();

			changeGetcmprlist(changecmpr).then(res => {
				if (res.data.code >= 0) {
					this.examinetableData = Array.from(res.data.data.list);
					this.examinetableDataesli = this.examinetableData;
				}
			});
		},

		// 改变学校
		changesrebiltyval() {
			this.abilityproject = '';
			let rebiltyvobj = {};
			// console.log(this.rebiltyvalue)
			this.rebiltyvaluelist.forEach(item => {
				if (item.pid == this.rebiltyvalue) {
					rebiltyvobj = item;
				}
			});
			// console.log(rebiltyvobj.parentProjectName)
			this.gerprojectname(rebiltyvobj.parentProjectName);
		},
		changezy(e) {
			let prolist = Array.from(this.prolist);

			let zyobj = prolist.filter(item => {
				return e == item.pro_guid;
			});
			this.zyobj = zyobj[0];
			// console.log(this.zyobj);
		},

		// 分隔器
		group(array, subNum) {
			let index = 0;
			let newArray = [];
			while (index < array.length) {
				newArray.push(array.slice(index, (index += subNum)));
			}
			return newArray;
		},
		// 获取类型
		gerproytype() {
			changeGetprojectType().then(res => {
				this.rebiltyvaluelist = res.data.data.list;
			});
		},
		gerprojectname(id) {
			changeGetprojectName(id).then(res => {
				this.abilityprojectlist = res.data.data.list;
			});
		},
		getprolist() {
			let siguid = localStorage.getItem('siguid');
			GetzyProfList(siguid).then(res => {
				this.prolist = res.data.data;
			});
		},
		changeallslec(e) {
			// console.log(e)
			this.delectcmguidlist = e;
		},
		changeselect(e) {
			// console.log(e)
			this.delectcmguidlist = e;
		},
		// 批量删除
		gouserslist() {
			let delectcmguidlist = [];
			this.delectcmguidlist.forEach(item => {
				delectcmguidlist.push(item.cm_guid);
			});

			if (delectcmguidlist.length == 0) {
				this.$message('请选择您所要删除的模型');
				return;
			}
			this.$confirm('改操作模型将被彻底删除，是否删除？', '提示', {
				confirmButtonText: '是',
				cancelButtonText: '否',
				type: 'warning',
				customClass: 'msgboxsa'
			})
				.then(() => {
					changeDeleteCm({
						cm_guid: delectcmguidlist
					}).then(res => {
						if (res.data.code == 1) {
							this.$message.success(res.data.msg);
							this.gfarzPageLogList();
						} else {
							this.$message(res.data.msg);
						}
					});
				})
				.catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消删除'
					// });
				});
		},
		// 删除
		clickprovisible(item) {
			// this.delectcmguidlist.push(item.cm_guid)
			// let delectcmguidlist = new Set(this.delectcmguidlist)
			// console.log(item);
			changeDeleteCm({
				cm_guid: [item.cm_guid]
			}).then(res => {
				if (res.data.code == 1) {
					this.$message.success(res.data.msg);
					this.gfarzPageLogList();
				} else {
					this.$message(res.data.msg);
				}
			});
		},

		// 启用和禁用
		changedisable(itm) {
			if (itm.pro_status == 1) {
				let chgdisobj = {
					cm_guid: itm.cm_guid,
					status: 0
				};

				changeDisabled(chgdisobj).then(res => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.gfarzPageLogList();
					} else {
						this.$message(res.data.msg);
					}
				});
			} else {
				let chgdisobj1 = {
					cm_guid: itm.cm_guid,
					status: 1
				};
				changeDisabled(chgdisobj1).then(res => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.gfarzPageLogList();
					} else {
						this.$message(res.data.msg);
					}
				});
			}
		},

		// 上一步下一步
		nextclicks() {
			if (this.stapactives == 1) {
				// console.log(this.models,"内容1111")
				if (this.models.cm_name == '') {
					this.$message('请输入内容名称');
					return;
				}

				if (this.models.pro_guid == '') {
					this.$message('请选择专业');
					return;
				}
				if (this.models.cm_content == '') {
					this.$message('请输入内容描述');
					return;
				}
				this.stapactives++;
				this.gerproytype();
			} else if (this.stapactives == 2) {
				if (this.examinetableData.length == 0) {
					this.$message('请添加内容列表');
				} else {
					this.stapactives++;
				}
			} else {
				let biltymodeobj = {
					cm_name: this.models.cm_name,
					pro_guid: this.models.pro_guid,
					pro_name: this.zyobj.pro_name,
					cm_content: this.models.cm_content,
					sx_projects: this.examinetableData
				};

				if (this.ismodels == 1) {
					biltymodeobj.cm_guid = this.models.cm_guid;
					biltymodeobj.cm_name = this.models.cm_name;
					chanputcapabilitymodelm(biltymodeobj).then(res => {
						if (res.data.code > 0) {
							this.centerDialogVisible = false;
							this.stapactives++;
							let models = {};
							this.models = models;
							// this.models.cm_name = '';
							// this.models.pro_guid = '';
							// this.models.cm_content = '';
							this.zyobj.pro_name = '';
							this.examinetableData = [];
							this.gfarzPageLogList();
							this.$message.success(res.data.msg);
						} else {
							this.$message(res.data.msg);
						}
					});
				} else {
					changecapabilitymodelm(biltymodeobj).then(res => {
						if (res.data.code > 0) {
							this.centerDialogVisible = false;
							this.stapactives++;
							let models = {};
							this.models = models;
							// this.models.cm_name = '';
							// this.models.pro_guid = '';

							// this.models.cm_content = '';
							this.zyobj.pro_name = '';
							this.examinetableData = [];
							this.gfarzPageLogList();
							this.$message.success(res.data.msg);
						} else {
							this.$message(res.data.msg);
						}
					});
				}
			}
		},
		prveclicks() {
			if (this.stapactives > 0) {
				this.stapactives--;
			}
		},

		// 上一页下一页删除
		prepspages() {
			this.abiltypageidx -= 1;
			// console.log(this.abiltypageidx);
			if (this.abiltypageidx > 0) {
				this.examinetableData = this.examinetableDataesli[this.abiltypageidx];
			}
		},
		nextpages() {
			this.abiltypageidx += 1;
			// console.log(this.abiltypageidx);
			if (this.examinetableDataesli.length - 1 >= this.abiltypageidx) {
				this.examinetableData = this.examinetableDataesli[this.abiltypageidx];
			}
		},
		delectesaf(obj) {
			this.examinetableData.splice(this.examinetableData.indexOf(obj), 1);

			this.examinetableDataesli = this.examinetableData;

			// console.log(this.examinetableData)
		},

		pagesizechanes() {
			this.gfarzPageLogList();
		},
		// 时间筛选
		stchangedate() {
			// console.log(this.vdate)
			let stdate = this.changegodate(this.vdate ?? '');
			this.sdate = stdate;
			this.gfarzPageLogList();
		},
		stchangedates() {
			let edatees = this.changegodate(this.edates);
			this.edate = edatees;
			this.gfarzPageLogList();
		},

		// 快速装换
		changegodate(date) {
			// console.log(date);
			let yy = new Date(date).getFullYear();
			let mm = new Date(date).getMonth() + 1;
			let dd = new Date(date).getDate();
			return yy + '/' + mm + '/' + dd;
		},

		tabledeletes(eve, itm) {},

		searchs() {
			this.gfarzPageLogList();
		},

		handleCurrentChange(val) {
			this.pageindex = val;
			this.gfarzPageLogList();
		},

		gfarzPageLogList() {
			let rzPageobj = {
				pageIndex: this.pageindex,
				pageSize: this.pagesize,
				strwhere: this.search
			};

			getGetcmpagelist(rzPageobj).then(res => {
				if (res.data.code == 1) {
					this.tableData = res.data.data.list;
					this.pagggenums = res.data.data.totalCount;
				}
			});
		},

		handleClick() {
			alert('button click');
		},
		handleClose(done) {
			this.$confirm('温馨提示！现在关闭将无法正常添加或编辑成功，请在步骤三点击完成', '提示', {
				customClass: 'msgboxsa'
			})
				.then(_ => {
					done();
				})
				.catch(_ => {});
		}
	}
};
</script>
